<template>
  <div class="embed-container">
    <div class="chat-container">
      <div class="fab-dialog-header">
        {{ ModalTitle }}
      </div>

      <div class="chat-messages" id="chat-box">
        <div
          v-for="(message, index) in messages"
          :key="index"
          :class="['message', message.type]"
        >
          <div class="message-content">
            <div v-if="message.type === 'user'" class="user-message">
              <span class="icon">👤</span>
              <span class="message-text">{{ message.text }}</span>
            </div>
            <div v-else-if="message.type == 'support'" class="support-message">
              <span v-if="message.isBot == 1" class="icon">🤖</span>
              <span v-else class="icon">👩‍💼</span>
              <span v-html="formatSupportMessage(message.text)"> </span>
              <!-- <div v-if="message.similarity" class="similarity">
                میزان تطابق: {{ (message.similarity * 100).toFixed(1) }}%
              </div> -->
            </div>
            <div
              v-else-if="message.type == 'sample-question'"
              class="support-message"
            >
              <span>
                <span class="icon">🤖</span>
                سوالات متداول
              </span>

                  <div class="questions-grid">
                    <button
                      v-for="(q, i) in message.questions"
                      :key="i"
                      class="sample-question-btn"
                      @click="useSampleQuestion(q)"
                    >
                      {{ q }}
                    </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="loading-indicator">
          <div class="spinner"></div>
          <span>در انتظار پاسخ...</span>
        </div>
      </div>

      <div class="input-area">
        <textarea
          v-model="userInput"
          @keydown="handleKey"
          ref="textarea"
          @input="adjustHeight"
          placeholder="سوال خود را اینجا بنویسید..."
          :disabled="loading"
        ></textarea>
        <button @click="sendMessage" :disabled="loading || !userInput.trim()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="send-icon"
          >
            <path d="M22 3L1 12l21 9v-7l-15-2 15-2V3z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "ChatView",

  setup() {

      const ModalTitle = ref("");
      const route = useRoute();
      const welcomeMessage = ref("");
      const sampleQuestions = ref([]);
      const widgetId = ref(route.params.widgetId);

      const addWelcomeMessage = () => {
          messages.value.push({
            type: "support",
            text: welcomeMessage.value,
            similarity: null,
            isBot: 1,
          });
      };


      const addSampleQuestions = () => {
          messages.value.push({
              type: "sample-question",
              questions: sampleQuestions.value,
              similarity: null,
          });
      };

      const userInput = ref("");
      const textarea = ref(null);
      const messages = ref([]);
      const loading = ref(false);

      const scrollToBottom = () => {
         const chatBox = document.getElementById("chat-box");
         chatBox.scrollTop = chatBox.scrollHeight;
      };

      const handleKey = (e) => {
          if (e.key === "Enter" && e.shiftKey) {
              return;
          }
          if (e.key === "Enter") {
              e.preventDefault();
              sendMessage();
          }
      };


      function formatSupportMessage(text) {
          const urlRegex = /(?:https?:\/\/)?(?:www\.)?([\w-]+\.\w{2,})(\/[^\s]*)?/g;
          const withLinks = text.replace(urlRegex, (match) => {
          const url = match.startsWith("http") ? match : `https://${match}`;
            return `<a href="${url}" class="support-link" target="_blank">${match}</a>`;
          });
          return withLinks.replace(/\n/g, "<br>");
      }

       const adjustHeight = () => {
           const el = textarea.value;
           if (el) {
               el.style.height = "1px";
               const height = el.scrollHeight;
               const maxHeight = parseInt(getComputedStyle(el).lineHeight) * 5;
               el.style.height = `${Math.min(height, maxHeight)}px`;
               el.style.overflowY = height > maxHeight ? "auto" : "hidden";
           }
       };


       const sendMessage = async () => {
           tryAdjust();

           const question = userInput.value.trim();
           if (!question) return;

           messages.value.push({
               type: "user",
               text: question,
           });

           userInput.value = "";

           setTimeout(() => {
               adjustHeight();
           }, 0);

           setTimeout(() => {
            scrollToBottom();
           }, 100);

           loading.value = true;
           try {
               const response = await axios.post(
                  `${process.env.VUE_APP_API_GOOMAI}/chat`,
                  {
                    question: question,
                    widgetId: widgetId.value,
                    token: token.value,
                  },
                  { withCredentials: true }
               );

               messages.value.push({
                  type: "support",
                  text: response.data.answer,
                  similarity: response.data.similarity,
                  isBot: response.data.is_bot,
               });

               setTimeout(() => {
                  scrollToBottom();
               }, 100);

           } catch (error) {

               console.error("Error:", error);
               messages.value.push({
                  type: "support",
                  text: "متاسفانه مشکلی در دریافت پاسخ پیش آمد. لطفاً دوباره تلاش کنید.",
                  similarity: null,
               });

           } finally {
                loading.value = false;
           }

       };

        const useSampleQuestion = (question) => {
          userInput.value = question;
          sendMessage();
        };

        const tryAdjust = () => {
          if (textarea.value && textarea.value.offsetHeight > 0) {
            adjustHeight();
          } else {
            setTimeout(tryAdjust, 50);
          }
        };

        const page = ref(1);
        const token = ref("");
        const rowCount = ref(600);

        function getMessageList(){
            axios({
                method: "POST",
                url:`${process.env.VUE_APP_API_GOOMAI}/messages`,
                data: {
                    page: page.value,
                    row_count: rowCount.value,
                    token: token.value,
                    widget_id: widgetId.value
                }
           }).then((response) => {

               const msgs = response.data.data.messages;
               if (Array.isArray(msgs) && msgs.length > 0) {
                   msgs.forEach(msg => {
                       messages.value.push({
                            type:  msg.is_bot? "support":"user",
                            text: msg.answer,
                            similarity: msg.similarity,
                            isBot: msg.is_bot
                      });
                   });
               }

           }).catch(error => {
               console.log("asdi",error)
           });

        }

        onMounted(() => {
          tryAdjust();
        });

        onMounted(async () => {
            const savedToken = localStorage.getItem(`goomai-${widgetId.value}`);
            if (savedToken) {
                token.value = savedToken;
            } else {
                const newToken = crypto.randomUUID();
                localStorage.setItem(`goomai-${widgetId.value}`, newToken);
                token.value = newToken;
            }

            try {
                const response = await axios.post(
                  `${process.env.VUE_APP_API_GOOMAI}/widget/chat/setting/${widgetId.value}`,
                   {},
                   { withCredentials: true }
                );

                welcomeMessage.value = response.data.setting.welcome_message;
                sampleQuestions.value = response.data.setting.faq;
                ModalTitle.value = response.data.setting.modal_title;

                addWelcomeMessage();
                addSampleQuestions();

                const root = document.documentElement;
                root.style.setProperty(
                   "--primary-color",
                   response.data.setting.primary_color
                ); //#a54471
                root.style.setProperty(
                  "--secondary-color",
                  response.data.setting.secondary_color
                ); //#E6A1B8
                root.style.setProperty(
                  "--box-text-color",
                  response.data.setting.box_text_color
                ); //#A54471
                root.style.setProperty(
                  "--light-color",
                  response.data.setting.light_color
                ); //#FFEEF4
                root.style.setProperty(
                  "--support-box-color",
                  response.data.setting.support_box_color
                ); //#FFEEF4
                root.style.setProperty(
                  "--userBox-color",
                  response.data.setting.user_box_color
                );
                 root.style.setProperty(
                  "--primary-text-color",
                  response.data.setting.primary_text_color
                 );
            }catch (error) {
                console.error("خطا در ارسال:", error.message);
            }
            getMessageList();


        });
        return {
          userInput,messages,loading,sendMessage,useSampleQuestion,
          handleKey,textarea,adjustHeight,sampleQuestions,addSampleQuestions,
          formatSupportMessage,ModalTitle,getMessageList,page,rowCount,token,widgetId
        };
  },
};
</script>

<style scoped>
.embed-container {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.chat-container {
  direction: rtl;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.chat-messages {
  flex: 1;
  padding: 17px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.message {
  margin-bottom: 16px;
  display: flex;
  line-height: 1.5;
}

.message.user {
  text-align: right;
}

.message-content {
  max-width: 80%;
  font-size: 14px;
}

.user-message {
  margin-left: auto;
  text-align: justify;
  padding: 10px 15px;
  border-radius: 18px 18px 0 18px;
  display: inline-block;
  background-color: var(--userBox-color);
  color: var(--box-text-color);
}
.user-message span {
  word-break: break-word;
  line-height: 1.6;
}

.support-message {
  margin-right: auto;
  text-align: right;
  padding: 10px 15px;
  border-radius: 18px 18px 18px 0;
  display: inline-block;
  background-color: var(--support-box-color);
  color: var(--box-text-color);
}
.support-message span {
  line-height: 1.6;
}

.icon {
  margin-left: 8px;
  margin-right: 8px;
  font-size: 1.2em;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: #666;
}

.spinner {
  border: 3px solid;
  border-radius: 50%;
  border-top: 3px solid;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin-left: 10px;
  border-color: var(--secondary-color);
  border-top-color: var(--primary-color);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.input-area {
  position: relative;
  display: flex;
  font-size: 14px;
  /* border-top: 1px solid; */
  box-shadow: 0px 0px 5px;
  color: var(--primary-color);
  background-color: white;
}

.input-area textarea {
  width: 100%;
  direction: rtl;
  box-sizing: border-box;
  resize: none;
  font-family: inherit;
  outline: none;
  padding: 0;
  overflow-y: auto;
  height: 39px;
  padding: 9px;
  border: none;
  text-align: justify;
  color: var(--box-text-color);
}
.input-area textarea::placeholder {
  color: #aaa;
}

.input-area button {
  border: none;
  cursor: pointer;
  align-self: flex-end;
  flex-shrink: 0;
  height: 32px;
  background-color: inherit;
}

.input-area button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.questions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 22px;
  padding: 8px 9px;
}
.sample-question-btn {
  border-radius: 11px;
  padding: 7px;
  text-align: right;
  border: none;
  color: var(--primary-text-color);
  background-color: var(--primary-color);
  outline: none;
}

.message.sample-question {
  display: flex;
  justify-content: end;
}
.message.support {
  display: flex;
  justify-content: end;
}
.send-icon {
  fill: var(--primary-color);
}
.message-text {
  white-space: pre-wrap;
}

::v-deep(a.support-link) {
  color: var(--box-text-color);
  display: inline;
  text-decoration: underline;
}
::v-deep(a.support-link:hover) {
  color: var(--primary-color);
}

.fab-dialog-header {
  background-color: var(--primary-color);
  padding: 15px 27px;
  justify-content: space-between;
  position: relative;
}

.fab-dialog-header {
  display: flex;
  align-items: center;
  color: var(--primary-text-color);
}
</style>
